/**
 * Cookie Consent Modal
 * Handles cookie consent functionality
 */


  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  // Default all to denied (example) – adjust to your policy
  gtag('consent','default',{
    ad_storage:'denied',
    ad_user_data:'denied',
    ad_personalization:'denied',
    analytics_storage:'denied',
    wait_for_update:500
  });




window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     // Rescue error
   }
   // If error is false, the API has loaded and ready to use!
 },
);

class CookieConsent {
  constructor() {
    this.modal = null;
    this.isInitialized = false;
    this.cookieName = 'cookie_consent';
    this.cookieExpireDays = 540; // Only change this in this function.
    this.currentMode = 'age_notice';
    this.cssLoaded = false;
    this.geoDetectionDone = false;
    this.geoMismatch = false;
    this.geoAckCookieName = 'geo_ack';
    this.geoAckExpireDays = 30;
    this.geoDetectTimeoutMs = 2000;
    this.initialPageShown = false;
    this._geoDetectionPromise = null;
  }

  /**
   * Load the cookie consent CSS dynamically
   */
  loadCss() {
    if (this.cssLoaded || !window.cookieConsentCssUrl) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = window.cookieConsentCssUrl;
    link.onload = () => {
      if (this.modal) {
        this.modal.style.display = '';
      }
    };
    document.head.appendChild(link);
    this.cssLoaded = true;
  }

  /**
   * Initialize the cookie consent modal
   * Automatically opens modal on page load if consent hasn't been given
   */
  init() {
    if (this.isInitialized) return;

    this.modal = document.getElementById('cookie-consent-modal');
    if (!this.modal) {
      console.error('CMP~Cookie consent modal not found');
      return;
    }

    this.bindEvents();
    this.setModalContent();
    this.isInitialized = true;

    const cookieParam = this.getUrlParameter('cookie');
    if (cookieParam !== null) {
      this.handleCookieParameter();
      return;
    }

    this.setupGeoDetection().then(() => this.showInitialPage());
  }

  /**
   * Open geo first on an IP mismatch, otherwise cookies, otherwise nothing.
   */
  showInitialPage() {
    if (this.initialPageShown) return;
    this.initialPageShown = true;

    const needsGeo = this.geoMismatch && !this.hasGeoAck();
    const needsCookies = !this.hasConsent();

    if (needsGeo) {
      this.setModalContent('geo_only');
      this.open();
      return;
    }

    if (needsCookies) {
      this.setModalContent('age_notice');
      this.open();
    }
  }

  /**
   * Set the modal content with HTML from translations
   */
  setModalContent(mode = 'age_notice') {
    if (!window.cookieConsentTranslations) return;

    this.currentMode = mode;
    this.resetGeoOnlyChrome(mode);

    if (mode === 'geo_only') {
      // Compact "correct your region" prompt (shown to already-consented visitors)
      this.setupGeoOnly();
    } else {
      this.restoreCurrentStoreRelocationNotice();

      const translations = window.cookieConsentTranslations[mode];

      // Set the modal title
      const titleElement = document.getElementById('cookie-consent-title');
      if (titleElement) {
        const decodedTitle = this.decodeHtmlEntities(translations.title);
        titleElement.innerHTML = decodedTitle;
      }

      // Handle different content based on mode
      if (mode === 'cookie_preferences') {
        this.setupCookiePreferences(translations);
      } else {
        this.setupBasicContent(translations);
      }

      // Set button texts and styling
      this.setupButtons(mode, translations);
    }

    this.updateGeoVisibility();
  }

  /**
   * Country switcher is its own page (geo_only). Age/cookies never show it.
   */
  updateGeoVisibility() {
    const geoSection = this.modal.querySelector('[data-geo-section]');
    if (!geoSection) return;
    geoSection.style.display = this.currentMode === 'geo_only' ? '' : 'none';
  }

  /**
   * Configure the compact geo-only prompt: hide the age/cookie chrome and show
   * the switcher + a Confirm button.
   */
  setupGeoOnly() {
    this.modal.classList.add('cookie-consent-modal--geo-only');
    this.modal.classList.remove('cookie-consent-modal--preferences');

    const header = this.modal.querySelector('.cookie-consent-modal__header');
    const body = this.modal.querySelector('.cookie-consent-modal__body');
    const buttons = this.modal.querySelector('.cookie-consent-modal__buttons');
    const confirm = this.modal.querySelector('[data-geo-confirm]');

    if (header) header.style.display = 'none';
    if (body) body.style.display = 'none';
    if (buttons) buttons.style.display = 'none';
    this.hidePreferencesElements();
    if (confirm) confirm.classList.remove('hidden');
  }

  /**
   * Restore the standard age/cookie chrome when leaving (or not entering) geo_only.
   */
  resetGeoOnlyChrome(mode) {
    if (mode === 'geo_only') return;

    this.modal.classList.remove('cookie-consent-modal--geo-only');

    const header = this.modal.querySelector('.cookie-consent-modal__header');
    const body = this.modal.querySelector('.cookie-consent-modal__body');
    const buttons = this.modal.querySelector('.cookie-consent-modal__buttons');
    const confirm = this.modal.querySelector('[data-geo-confirm]');

    if (header) header.style.display = '';
    if (body) body.style.display = '';
    if (buttons) buttons.style.display = '';
    if (confirm) confirm.classList.add('hidden');
  }

  /**
   * Setup basic content for age_notice and age_verification modes
   */
  setupBasicContent(translations) {
    // Remove preferences mode class from modal
    this.modal.classList.remove('cookie-consent-modal--preferences');
    
    // Show the modal body
    const modalBody = this.modal.querySelector('.cookie-consent-modal__body');
    if (modalBody) {
      modalBody.classList.remove('cookie-consent-modal__body--hidden');
    }
    
    const contentElement = document.getElementById('cookie-consent-description');
    if (contentElement) {
      const decodedContent = this.decodeHtmlEntities(translations.content);
      contentElement.innerHTML = decodedContent;
    }
    
    // Hide preferences elements
    this.hidePreferencesElements();
  }

  /**
   * Setup cookie preferences content
   */
  setupCookiePreferences(translations) {
    // Add preferences mode class to modal
    this.modal.classList.add('cookie-consent-modal--preferences');
    
    // Hide the modal body
    const modalBody = this.modal.querySelector('.cookie-consent-modal__body');
    if (modalBody) {
      modalBody.classList.add('cookie-consent-modal__body--hidden');
    }
    
    // Show preferences elements
    this.showPreferencesElements();
    
    // Set preference content
    const controlHeader = document.getElementById('control-header');
    const controlContent = document.getElementById('control-content');
    const benefitsHeader = document.getElementById('benefits-header');
    const benefitsContent = document.getElementById('benefits-content');
    
    if (controlHeader) {
      controlHeader.innerHTML = this.decodeHtmlEntities(translations.control_header);
    }
    
    if (controlContent) {
      controlContent.innerHTML = this.decodeHtmlEntities(translations.control_content);
    }
    
    if (benefitsHeader) {
      benefitsHeader.innerHTML = this.decodeHtmlEntities(translations.accept_benefits_header);
    }
    
    if (benefitsContent) {
      benefitsContent.innerHTML = this.decodeHtmlEntities(translations.accept_benefits_content);
    }
    
    // Set up cookie categories
    this.setupCookieCategories(translations.categories);
  }

  /**
   * Setup buttons based on mode
   */
  setupButtons(mode, translations) {
    const acceptButton = this.modal.querySelector('[data-cookie-accept]');
    const declineButton = this.modal.querySelector('[data-cookie-decline]');
    const saveButton = this.modal.querySelector('[data-cookie-save]');
    const buttonsContainer = this.modal.querySelector('.cookie-consent-modal__buttons');
    
    // Always hide save button by default, only show in cookie_preferences mode
    if (saveButton) {
      saveButton.classList.add('hidden');
    }
    
    if (mode === 'cookie_preferences') {
      // Add preference styling to buttons container
      if (buttonsContainer) {
        buttonsContainer.classList.add('cookie-consent-modal__buttons--preferences');
      }
      // Cookie preferences mode
      if (acceptButton) {
        acceptButton.innerHTML = this.decodeHtmlEntities(translations.accept_all);
      }
      
      if (declineButton) {
        declineButton.innerHTML = this.decodeHtmlEntities(translations.decline_all);
        declineButton.classList.remove('cookie-consent-modal__btn--under-18');
      }
      
      if (saveButton) {
        saveButton.innerHTML = this.decodeHtmlEntities(translations.save_choices);
        saveButton.classList.remove('hidden');
      }
    } else {
      // Age notice or age verification modes
      // Remove preference styling from buttons container
      if (buttonsContainer) {
        buttonsContainer.classList.remove('cookie-consent-modal__buttons--preferences');
      }
      
      if (acceptButton) {
        const acceptText = translations.accept || translations.accept_all;
        acceptButton.innerHTML = this.decodeHtmlEntities(acceptText);
      }
      
      if (declineButton) {
        const declineText = translations.decline || translations.decline_all;
        declineButton.innerHTML = this.decodeHtmlEntities(declineText);
        
        // Update button styling based on mode
        if (mode === 'age_verification') {
          declineButton.classList.add('cookie-consent-modal__btn--under-18');
        } else {
          declineButton.classList.remove('cookie-consent-modal__btn--under-18');
        }
      }
    }
  }

  /**
   * Setup cookie categories content and event listeners
   */
  setupCookieCategories(categories) {
    // Set category titles and descriptions
    const categoryMapping = {
      'operate_website': { title: 'category-operate-title', description: 'category-operate-description' },
      'store_preferences': { title: 'category-store-title', description: 'category-store-description' },
      'personalise_marketing': { title: 'category-marketing-title', description: 'category-marketing-description' },
      'measure_performance': { title: 'category-performance-title', description: 'category-performance-description' }
    };
    
    Object.keys(categoryMapping).forEach(categoryKey => {
      const category = categories[categoryKey];
      const mapping = categoryMapping[categoryKey];
      
      const titleElement = document.getElementById(mapping.title);
      const descriptionElement = document.getElementById(mapping.description);
      
      if (titleElement && category) {
        titleElement.innerHTML = this.decodeHtmlEntities(category.title);
      }
      
      if (descriptionElement && category) {
        descriptionElement.innerHTML = this.decodeHtmlEntities(category.description);
      }
    });
    
    // Add event listeners to checkboxes
    this.setupCheckboxListeners();
  }

  /**
   * Setup checkbox event listeners
   */
  setupCheckboxListeners() {
    const checkboxes = this.modal.querySelectorAll('.cookie-consent-modal__category-checkbox:not([disabled])');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updateSaveButton());
    });
  }

  /**
   * Update save button state based on checkbox selections
   */
  updateSaveButton() {
    const saveButton = this.modal.querySelector('[data-cookie-save]');
    if (!saveButton) return;
    
    const checkboxes = this.modal.querySelectorAll('.cookie-consent-modal__category-checkbox:not([disabled])');
    const hasSelection = Array.from(checkboxes).some(checkbox => checkbox.checked);
    
    if (hasSelection) {
      saveButton.disabled = false;
      saveButton.classList.remove('cookie-consent-modal__btn--save');
      saveButton.classList.add('cookie-consent-modal__btn--save-active');
    } else {
      saveButton.disabled = true;
      saveButton.classList.add('cookie-consent-modal__btn--save');
      saveButton.classList.remove('cookie-consent-modal__btn--save-active');
    }
  }

  /**
   * Show cookie preferences elements
   */
  showPreferencesElements() {
    const separator = this.modal.querySelector('.cookie-consent-modal__separator');
    const preferences = this.modal.querySelector('.cookie-consent-modal__preferences');
    
    if (separator) separator.classList.remove('hidden');
    if (preferences) preferences.classList.remove('hidden');
  }

  /**
   * Hide cookie preferences elements
   */
  hidePreferencesElements() {
    const separator = this.modal.querySelector('.cookie-consent-modal__separator');
    const preferences = this.modal.querySelector('.cookie-consent-modal__preferences');
    
    if (separator) separator.classList.add('hidden');
    if (preferences) preferences.classList.add('hidden');
  }

  /**
   * Bind open/close + keyboard behaviour for the age_notice country switcher.
   * Mirrors the header locale selector (sections/header.liquid). The options are
   * plain <a> links, so selecting one navigates to the sibling store.
   */
  bindGeoDropdown() {
    const selector = this.modal.querySelector('#agegate-locale');
    const btn = this.modal.querySelector('#agegate-locale-btn');
    const dropdown = this.modal.querySelector('#agegate-locale-dropdown');
    if (!selector || !btn || !dropdown) return;

    const openDropdown = () => {
      dropdown.classList.remove('hidden');
      btn.setAttribute('aria-expanded', 'true');
      const first = dropdown.querySelector('.agegate-locale__option');
      if (first) first.focus();
    };
    const closeDropdown = () => {
      dropdown.classList.add('hidden');
      btn.setAttribute('aria-expanded', 'false');
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    // Keep clicks inside the dropdown from bubbling out
    dropdown.addEventListener('click', (e) => e.stopPropagation());

    dropdown.querySelectorAll('.agegate-locale__option').forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectGeoOption(opt);
        closeDropdown();
        btn.focus();
      });
    });

    // Outside click closes the dropdown
    document.addEventListener('click', (e) => {
      if (dropdown.classList.contains('hidden')) return;
      if (!selector.contains(e.target)) closeDropdown();
    });

    // Keyboard navigation (scoped to the dropdown so it doesn't fight the modal's
    // global Escape handler, which keeps the modal itself open)
    dropdown.addEventListener('keydown', (e) => {
      const options = Array.from(dropdown.querySelectorAll('.agegate-locale__option'));
      const currentIndex = options.indexOf(document.activeElement);

      switch (e.key) {
        case 'Escape':
          e.preventDefault();
          e.stopPropagation();
          closeDropdown();
          btn.focus();
          break;
        case 'ArrowDown':
          e.preventDefault();
          options[currentIndex < options.length - 1 ? currentIndex + 1 : 0].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          options[currentIndex > 0 ? currentIndex - 1 : options.length - 1].focus();
          break;
        case 'Home':
          e.preventDefault();
          options[0].focus();
          break;
        case 'End':
          e.preventDefault();
          options[options.length - 1].focus();
          break;
      }
    });
  }

  /**
   * The market option currently selected in the country switcher, if any.
   */
  getSelectedGeoOption() {
    const container = this.modal.querySelector('#agegate-locale');
    if (!container) return null;
    return container.querySelector('.agegate-locale__option[aria-selected="true"]');
  }

  /**
   * Whether a switcher option (or the current selection) differs from this storefront.
   */
  isGeoOptionDifferentFromCurrentStore(opt) {
    const container = this.modal.querySelector('#agegate-locale');
    const selected = opt || this.getSelectedGeoOption();
    if (!container || !selected) return false;

    const currentIso = String(container.getAttribute('data-current-iso') || '').toLowerCase();
    const selectedIso = String(selected.getAttribute('data-iso') || '').toLowerCase();
    return selectedIso !== '' && selectedIso !== currentIso;
  }

  /**
   * Whether the switcher's selected market differs from this storefront's market.
   */
  isSelectedGeoMarketDifferent() {
    return this.isGeoOptionDifferentFromCurrentStore();
  }

  /**
   * Sibling storefront URL plus this page's path (current locale prefix stripped).
   */
  buildGeoMarketUrl(baseHref) {
    const root = String(
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    ).replace(/\/+$/, '');

    let path = window.location.pathname;
    if (root && path.startsWith(root)) {
      path = path.slice(root.length) || '/';
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }

    try {
      const target = new URL(baseHref, window.location.origin);
      const basePath = target.pathname.replace(/\/+$/, '');
      if (path === '/') {
        target.pathname = basePath ? `${basePath}/` : '/';
      } else {
        target.pathname = `${basePath}${path}`;
      }
      target.search = window.location.search;
      return target.href;
    } catch {
      return baseHref;
    }
  }

  /**
   * Navigate to the selected market's store URL when it differs from this storefront.
   * Returns true when navigation starts.
   */
  navigateToSelectedGeoMarket() {
    if (!this.isSelectedGeoMarketDifferent()) return false;

    const selected = this.getSelectedGeoOption();
    const baseHref = selected && selected.getAttribute('href');
    if (!baseHref) return false;

    window.location.href = this.buildGeoMarketUrl(baseHref);
    return true;
  }

  /**
   * Mark an option as the chosen region and sync the closed button's flag + label
   * to it. Does not navigate — Confirm builds the URL from the option's href + current path.
   */
  selectGeoOption(opt) {
    const container = this.modal.querySelector('#agegate-locale');
    if (!container || !opt) return;

    const options = Array.from(container.querySelectorAll('.agegate-locale__option'));
    options.forEach((o) => o.setAttribute('aria-selected', o === opt ? 'true' : 'false'));

    const labelEl = container.querySelector('[data-geo-label]');
    const flagEl = container.querySelector('[data-geo-flag]');
    const textEl = opt.querySelector('.agegate-locale__option-text');
    const flagImg = opt.querySelector('.agegate-locale__option-flag');
    if (labelEl && textEl) labelEl.textContent = textEl.textContent.trim();
    if (flagEl && flagImg) flagEl.src = flagImg.src;

    const iso = String(opt.getAttribute('data-iso') || '').toLowerCase();
    if (iso) this.updateRelocationNotice(iso);
  }

  /**
   * Per-market relocation copy (from cookie-consent-modal.liquid), keyed by ISO.
   */
  getRelocationNotices() {
    return (window.cookieConsentTranslations &&
      window.cookieConsentTranslations.age_notice &&
      window.cookieConsentTranslations.age_notice.relocation_notices) ||
      {};
  }

  /**
   * Age/cookies page always uses this storefront's relocation copy.
   */
  restoreCurrentStoreRelocationNotice() {
    const container = this.modal.querySelector('#agegate-locale');
    const currentIso = container && container.getAttribute('data-current-iso');
    if (currentIso) this.updateRelocationNotice(currentIso);
  }

  /**
   * Sync the relocation banner to the selected market's domain suffix message.
   */
  updateRelocationNotice(iso) {
    const noticeEl = this.modal.querySelector('[data-relocation-notice]');
    if (!noticeEl) return;

    const notices = this.getRelocationNotices();
    const text = notices[String(iso || '').toLowerCase()];
    if (text) noticeEl.textContent = this.decodeHtmlEntities(text);
  }

  /**
   * Same default-selection rule as applyGeoDetection: detected market when it
   * exists in the list, otherwise the current storefront market.
   */
  resolveDefaultGeoOption(container, detectedIso) {
    const currentIso = String(container.getAttribute('data-current-iso') || '').toLowerCase();
    const normalizedDetected = String(detectedIso || '').toLowerCase();
    const options = Array.from(container.querySelectorAll('.agegate-locale__option'));

    return (
      options.find(
        (opt) => normalizedDetected !== '' && opt.getAttribute('data-iso') === normalizedDetected
      ) ||
      options.find((opt) => opt.getAttribute('data-iso') === currentIso) ||
      null
    );
  }

  /**
   * Detect the visitor's physical country via Shopify's IP geolocation endpoint
   * (same source as assets/gtm-event-geo-locator.js) and update the switcher.
   * Runs once; failures leave the server-rendered defaults in place.
   */
  setupGeoDetection() {
    if (this._geoDetectionPromise) return this._geoDetectionPromise;

    const container = this.modal && this.modal.querySelector('#agegate-locale');
    if (!container) {
      this.geoDetectionDone = true;
      this._geoDetectionPromise = Promise.resolve();
      return this._geoDetectionPromise;
    }

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    this._geoDetectionPromise = new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        this.geoDetectionDone = true;
        resolve();
      };

      const timer = window.setTimeout(finish, this.geoDetectTimeoutMs);

      fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`)
        .then((res) => res.json())
        .then((data) => this.applyGeoDetection(data, container))
        .catch(() => {
          /* Detection is best-effort; skip the geo page on failure. */
        })
        .finally(() => {
          window.clearTimeout(timer);
          finish();
        });
    });

    return this._geoDetectionPromise;
  }

  /**
   * Apply the detected country to the heading and decide whether to show the
   * geo prompt.
   *
   * The detection payload's `country.handle` IS the ISO code (e.g. "US"), so it
   * compares directly against the current market's ISO (`data-current-iso`).
   * No mapping table, no market list — the rule is simply:
   *   physical location != current market  ->  show the prompt.
   */
  applyGeoDetection(data, container) {
    if (this.initialPageShown) return;

    const dv = (data && data.detected_values) || {};
    const country = dv.country || {};
    const detectedIso = String(country.handle || '').toLowerCase();
    const countryName = country.name || dv.country_name || '';
    const currentIso = String(container.getAttribute('data-current-iso') || '').toLowerCase();

    const headingEl = container.querySelector('[data-geo-heading]');
    const template = (window.cookieConsentTranslations.age_notice || {}).geo_heading || '';
    if (headingEl && countryName && template) {
      headingEl.textContent = this.decodeHtmlEntities(template).replace('[country]', countryName);
    }

    const selectedOption = this.resolveDefaultGeoOption(container, detectedIso);
    if (selectedOption) this.selectGeoOption(selectedOption);

    this.geoMismatch = detectedIso !== '' && detectedIso !== currentIso;
    this.updateGeoVisibility();
  }

  /**
   * Bind event listeners to modal elements
   */
  bindEvents() {
    // Country switcher dropdown (age_notice screen)
    this.bindGeoDropdown();

    const closeButtons = this.modal.querySelectorAll('[data-close-modal]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });

    const geoDismissButton = this.modal.querySelector('[data-geo-dismiss]');
    if (geoDismissButton) {
      geoDismissButton.addEventListener('click', () => this.dismissGeo());
    }

    // Accept button
    const acceptButton = this.modal.querySelector('[data-cookie-accept]');
    if (acceptButton) {
      acceptButton.addEventListener('click', () => this.accept());
    }

    // Decline button
    const declineButton = this.modal.querySelector('[data-cookie-decline]');
    if (declineButton) {
      declineButton.addEventListener('click', () => this.decline());
    }

    // Save button
    const saveButton = this.modal.querySelector('[data-cookie-save]');
    if (saveButton) {
      saveButton.addEventListener('click', () => this.saveChoices());
    }

    // Geo-only "Confirm" button (keep the visitor on the current store)
    const geoConfirmButton = this.modal.querySelector('[data-geo-confirm]');
    if (geoConfirmButton) {
      geoConfirmButton.addEventListener('click', () => this.confirmGeo());
    }

    // Prevent closing on overlay click - user must use buttons
    const overlay = this.modal.querySelector('.modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        // Prevent the click from closing the modal
        e.preventDefault();
        e.stopPropagation();
      });
    }

    // Prevent closing on Escape key - user must use buttons
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        // Prevent the Escape key from closing the modal
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  /**
   * Open the cookie consent modal
   */
  open() {
    if (!this.modal) return;

    this.loadCss();
    this.setupGeoDetection();
    this.modal.classList.remove('hidden');
    this.modal.setAttribute('open', '');
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    // Focus management
    this.modal.focus();
    
    // Trap focus within modal (using existing theme focus trap if available)
    if (typeof trapFocus === 'function') {
      trapFocus(this.modal);
    }
  }

  /**
   * Yield so the browser can paint the modal dismissal before consent/tag work.
   * Do not call scheduler.yield() unguarded — Safari has no scheduler global.
   */
  _yieldToMain() {
    if (globalThis.scheduler?.yield) return globalThis.scheduler.yield();
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  /**
   * Run Shopify / Consent Mode updates AFTER the dismissal has had a chance to
   * paint, so they do not sit inside the Agree/Save click (INP).
   */
  _deferConsentPropagation(payload, updateGtag) {
    const run = () => {
      try {
        window.Shopify?.customerPrivacy?.setTrackingConsent(payload, () => {});
      } catch (e) {
        console.error('CMP defer setTrackingConsent', e);
      }
      if (updateGtag && typeof gtag === 'function') {
        try {
          gtag('consent', 'update', {
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            ad_storage: 'granted',
            analytics_storage: 'granted',
          });
        } catch (e) {
          console.error('CMP defer gtag', e);
        }
      }
    };
    // Double rAF = after the next paint. setTimeout(0) / scheduler.yield()
    // are a task boundary but Chrome can still run that task before paint,
    // which would keep the tag burst inside INP as presentation delay.
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => requestAnimationFrame(run));
    } else {
      this._yieldToMain().then(run);
    }
  }

  /**
   * Close the cookie consent modal
   */
  close() {
    if (!this.modal) return;

    this.modal.classList.add('is-closing');
    
    setTimeout(() => {
      this.modal.removeAttribute('open');
      this.modal.classList.add('hidden');
      this.modal.classList.remove('is-closing');
      
      // Restore body scroll
      document.body.style.overflow = '';
      
      // Remove focus trap
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }
    }, 0);
  }

  /**
   * Handle accept action based on current mode
   */
  accept() {
    if (this.currentMode === 'age_notice') {
      this.setConsent(true);
      this.close();
      this._deferConsentPropagation({
        preferences: true,
        marketing: true,
        analytics: true,
        sale_of_data: true,
      }, true);
    } else if (this.currentMode === 'age_verification') {
      // User confirmed they are 18+ and want to manage cookies
      this.setModalContent('cookie_preferences');
    } else if (this.currentMode === 'cookie_preferences') {
      // User chose "Accept All" in cookie preferences
      this.selectAllCategories();
      this.setConsent(true);
      this.close();
    }
  }

  /**
   * Handle decline action based on current mode
   */
  decline() {
    if (this.currentMode === 'age_notice') {
      // Switch to age verification mode
      this.setModalContent('age_verification');
    } else if (this.currentMode === 'age_verification') {
      // User is under 18, redirect them
      this.handleUnder18();
    } else if (this.currentMode === 'cookie_preferences') {
      // User chose "Decline All" in cookie preferences
      this.selectOnlyMandatoryCategories();
      this.setConsent(false);
      this.close();
    }
  }

  /**
   * Handle under 18 action
   */
handleUnder18() {
  const rootUrl = window.Shopify.routes.root || "/";

  const redirects = {
    "/": "https://www.nhs.uk/live-well/quit-smoking/",                   // UK
    "/fr-fr/": "https://www.tabac-info-service.fr/",                                                          // France
    "/de-de/": "https://www.rauchfrei-info.de/",                                                              // Germany
    "/de-at/": "https://www.gesundheit.gv.at/leben/gesundheitsvorsorge/gesund-bleiben/rauchen-nichtrauchen", // Austria
    "/es-es/": "https://www.who.int/health-topics/tobacco"                         // Spain
  };

  const fallback = "https://www.who.int/health-topics/tobacco";
  window.location.href = redirects[rootUrl] || fallback;
}




    /**
   * Save Choice Section
   */
saveChoices() {
  const LOG = "CMP~SHP";
  

  // Example shape:
  // { operate_website: true, store_preferences: false, personalise_marketing: true, measure_performance: false }
  const selected = this.getSelectedCategories() || {};

  // Start from all false (A)
  const payload = {
    preferences:  false,
    marketing:    false,
    analytics:    false,
    sale_of_data: false
  };

  // B: operate_website does nothing (intentionally ignored)

  // Map the others to their fields
  if (selected.store_preferences) {
    payload.preferences = true;
  }

  // C: personalise_marketing sets BOTH marketing AND sale_of_data
  if (selected.personalise_marketing) {
    payload.marketing = true;
    payload.sale_of_data = true;
  }

  if (selected.measure_performance) {
    payload.analytics = true;
  }

  try {
    this.setConsent(true);
  } catch (e) {
    console.error(`${LOG} this.setConsent(true) failed:`, e);
  }

  try {
    this.close();
  } catch (e) {
    console.error(`${LOG} this.close() failed:`, e);
  }

  this._deferConsentPropagation(payload, false);
}
  /**
   * Get selected cookie categories
   */
  getSelectedCategories() {
    const checkboxes = this.modal.querySelectorAll('.cookie-consent-modal__category-checkbox');
    const selected = {};
    
    checkboxes.forEach(checkbox => {
      const category = checkbox.getAttribute('data-category');
      selected[category] = checkbox.checked;
    });
    
    return selected;
  }

  /**
   * Select all cookie categories
   */
  selectAllCategories() {
    const checkboxes = this.modal.querySelectorAll('.cookie-consent-modal__category-checkbox:not([disabled])');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });
    this.updateSaveButton();
  }

  /**
   * Select only mandatory cookie categories
   */
  selectOnlyMandatoryCategories() {
    const checkboxes = this.modal.querySelectorAll('.cookie-consent-modal__category-checkbox:not([disabled])');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    this.updateSaveButton();
  }

  /**
   * Confirm the selected region. Redirect when it differs; otherwise continue
   * to cookies on this storefront. Never writes cookie_consent.
   */
  confirmGeo() {
    this.setGeoAck();

    if (this.navigateToSelectedGeoMarket()) {
      return;
    }

    this.continueAfterGeo();
  }

  /**
   * Close the geo page without navigating: stay on this store, then cookies.
   */
  dismissGeo() {
    this.setGeoAck();
    this.continueAfterGeo();
  }

  continueAfterGeo() {
    if (!this.hasConsent()) {
      this.setModalContent('age_notice');
      return;
    }

    this.close();
  }

  /**
   * Remember that the visitor has acknowledged the geo prompt for this store.
   */
  setGeoAck() {
    this.setCookie(this.geoAckCookieName, '1', this.geoAckExpireDays);
  }

  /**
   * Whether the visitor has already acknowledged the geo prompt.
   */
  hasGeoAck() {
    return this.getCookie(this.geoAckCookieName) !== null;
  }

  /**
   * Check if user has given consent
   */
  hasConsent() {
    return this.getCookie(this.cookieName) !== null;
  }

  /**
   * Set consent cookie
   */
  setConsent(accepted, customMinutes = null) {
    const value = accepted ? 'accepted' : 'declined';
    if (customMinutes !== null) {
      this.setCookieInMinutes(this.cookieName, value, customMinutes);
    } else {
      this.setCookie(this.cookieName, value, this.cookieExpireDays);
    }
  }

  /**
   * Check if modal is currently open
   */
  isOpen() {
    return this.modal && this.modal.hasAttribute('open');
  }

  /**
   * Decode HTML entities that were escaped by Liquid's json filter
   */
  decodeHtmlEntities(text) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  /**
   * Set cookie helper
   */
  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  /**
   * Get cookie helper
   */
  getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  /**
   * Set cookie with expiration in minutes
   */
  setCookieInMinutes(name, value, minutes) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (minutes * 60 * 1000));
    const cookieString = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    document.cookie = cookieString;
  }

  /**
   * Get URL parameter value
   */
  getUrlParameter(name) {
    // Try URLSearchParams first (modern browsers)
    if (typeof URLSearchParams !== 'undefined') {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
      } catch (e) {
        
      }
    }
    
    // Fallback method using regex
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * Auto-accept cookies with custom duration in minutes
   */
  autoAcceptWithCustomDuration(minutes) {
    // Set consent cookie with custom expiration FIRST
    this.setConsent(true, minutes);
    
    // Tell Shopify's Customer Privacy API that all categories are accepted
    if (window?.Shopify?.customerPrivacy?.setTrackingConsent) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          preferences: true,
          marketing: true,
          analytics: true,
          sale_of_data: true  
        }, () => {
        });
      } catch (e) {
        console.error('CMP~autoAccept: setTrackingConsent failed:', e);
      }
    }
    
    // Update Google consent
    if (typeof gtag === 'function') {
      try {
        gtag('consent','update',{
          ad_user_data:'granted',
          ad_personalization:'granted',
          ad_storage:'granted',
          analytics_storage:'granted'
        });
      } catch (e) {
        console.error('CMP~autoAccept: gtag failed:', e);
      }
    }
  }

  /**
   * Handle cookie parameter - sets cookie for 1 hour when ?cookie is present
   */
  handleCookieParameter() {
    // Set consent cookie for 1 hour (60 minutes)
    this.setConsent(true, 60);
    
    // Tell Shopify's Customer Privacy API that all categories are accepted
    if (window?.Shopify?.customerPrivacy?.setTrackingConsent) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          preferences: true,
          marketing: true,
          analytics: true,
          sale_of_data: true  
        }, () => {
        });
      } catch (e) {
        console.error('CMP~handleCookieParameter: setTrackingConsent failed:', e);
      }
    }
    
    // Update Google consent
    if (typeof gtag === 'function') {
      try {
        gtag('consent','update',{
          ad_user_data:'granted',
          ad_personalization:'granted',
          ad_storage:'granted',
          analytics_storage:'granted'
        });
      } catch (e) {
        console.error('CMP~handleCookieParameter: gtag failed:', e);
      }
    }
  }
}

// Initialize cookie consent when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const cookieConsent = new CookieConsent();
  window.cookieConsentInstance = cookieConsent;
  cookieConsent.init();
});

// Export for global access if needed
window.CookieConsent = CookieConsent; 